<template>
    <div>
        <div class="page-title">形象定位</div>
        
        <profile-plane @planeChanged="planeChanged" :planes="planes" @syncPlane="syncPlane" :activeId="activeId"
                       @changeDefault="changeDefault"
                       @deletePlane="deletePlane"
                       @showMobileLocation="handleShowMobileLocation"
        >
            
            <div class="ip-box">
                
                <div class="module-list flex flex-left-center">
                    <template v-for="(item,ik) in modules">
                        <div class="module-item" :class="{disabled:item.app_id === 0}" :key="ik"
                             @click="activeCateModal(item)">
                            <div class="module-name">{{ item.module_name }}</div>
                        </div>
                    </template>
                </div>
                <div class="ip-creator" @click="activeCateModal" v-if="plane.app_id">添加分类<span>+</span></div>
            
            </div>
        
        
        </profile-plane>
        
        <at-modal title="添加分类" v-model="showCateModal" @ok="save">
            <p>请输入分类名称</p>
            <at-input class="full-with mb-5" v-model="cateParams.name"/>
            <p>请输入分类排序 <small>(从1开始数字越小排序越靠前)</small></p>
            <at-input class="full-with" v-model="cateParams.sort"></at-input>
        </at-modal>
    
    
    </div>
</template>

<script>

import api from "@/repo/api";
import ProfilePlane from "@/views/AST/MemberProfile/Com/ProfilePlane.vue";
import AtModal from "@/components/AtModal.vue";
import AtInput from "@/components/AtInput.vue";

export default {
    name: "ImagePosition",
    components: {AtInput, AtModal, ProfilePlane},
    data() {
        return {
            planeId: 0,
            showCateModal: false,
            list: [],
            planes: [],
            activeId: 0,
            plane: {},
            cateParams: {},
            modules: []
        }
    },
    mounted() {
        this.getTemplates()
    },
    methods: {
        activeCateModal(item = {}) {
            
            if (item.id && item.app_id === 0) return;
            
            this.cateParams = {
                name: item.module_name,
                id: item.id,
                sort: item.sort || ''
            }
            this.showCateModal = true
        },
        planeChanged(plane) {
            this.activeId = plane.id
            this.plane = plane
            this.getModules()
        },
        save() {
            this.$loading.show()
            
            const params = JSON.parse(JSON.stringify(this.cateParams))
            
            params.template_id = this.plane.id
            
            api.post('/ast-member-profile/sync-module', params).then(res => {
                this.$loading.hide()
                this.$message.data(res)
                
                if (res.code === 0) {
                    this.showCateModal = false
                    this.getModules()
                }
                
            })
        },
        getModules() {
            api.get('/ast-member-profile/modules', {
                template_id: this.plane.id
            }).then(res => {
                this.modules = res.data
            })
        },
        changeDefault(id) {
            
            api.post('/ast-member-profile/change-default-module-template', {id}).then(res => {
                
                this.$message.data(res)
                
                if (res.code !== 0) return;
                
                this.planes.forEach(item => {
                    if (item.id === id) {
                        item.is_default = 1
                    } else {
                        item.is_default = 0
                    }
                })
                
            })
        },
        syncPlane(params, callback) {
            
            this.$loading.show()
            
            api.post('/ast-member-profile/sync-module-template', params).then(res => {
                
                this.$message.data(res)
                
                this.$loading.hide()
                
                if (res.code !== 0) return;
                
                const idx = this.planes.findIndex(item => item.id === params.id)
                
                if (idx === -1) {
                    this.planes.push(res.data)
                } else {
                    this.planes.splice(idx, 1, res.data)
                }
                
                this.activeId = res.data.id
                
                callback()
            })
            
        },
        handleShowMobileLocation(){
            this.$previewImages('https://static.ycsd.work/col/member-profile-preview.png')
        },
        deletePlane(id) {
            
            this.$confirm({
                title: '确认删除模板吗？',
                type: 'warning',
                onOk: () => {
                    
                    this.$loading.show()
                    
                    api.post('/ast-member-profile/delete-module-template', {id}).then(res => {
                        this.$message.data(res)
                        this.$loading.hide()
                        this.planes.splice(
                            this.planes.findIndex(item => item.id === id),
                            1
                        )
                    })
                }
            })
            
        },
        getTemplates() {
            api.get('/ast-member-profile/module-templates').then(res => {
                this.planes = res.data
            })
        },
    }
}
</script>

<style scoped lang="less">

.ip-creator {
    width: 468px;
    height: 54px;
    background: linear-gradient(90deg, #EDFAFD 0%, #FFFFFF 100%);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #01B8DC;
    cursor: pointer;
    
    span {
        margin-left: 8px;
    }
}

.module-list {
    flex-wrap: wrap;
}

.module-item {
    width: 468px;
    height: 54px;
    background: linear-gradient(90deg, #EDFAFD 0%, #FCFCFC 100%);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #EEEEEE;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    padding: 0 19px 0 44px;
    position: relative;
    margin-right: 16px;
    margin-bottom: 24px;
    cursor: pointer;
    
    &.disabled {
        color: rgba(51, 51, 51, 0.71);
        cursor: auto;
    }
    
    &::before {
        content: " ";
        background-image: url("/assets/icons/body-postion-item.png");
        background-size: 100%;
        width: 15px;
        height: 15px;
        position: absolute;
        left: 19px;
        top: 20px;
    }
}


</style>